import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw6902Handlers = [
  http.post<unknown, { data: { search: { getGoodsByFeature: { condition: { Page: string; }; }; }; }; }>(
    PlessService.SERVICE.getGoodsList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getGoodsList(Number(req.data.search.getGoodsByFeature.condition.Page)));
    }
  ),
  http.post(
    PlessService.SERVICE.getExistingGoodsCopy.url,
    async () => {
      return HttpResponse.json(getExistingGoodsCopy);
    }
  ),

];

const getGoodsList = (pageNum: number) => ({
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: 200,
      StartDispNum: (pageNum - 1) * 100 + 1,
      EndDispNum: pageNum * 100,
      GoodsList: [
        {
          GuideGoodsName: '商品A',
          GuideStandardName: '規格A',
          JanCode: '123456789012',
          BuyerName: 'バイヤーA',
          PCode: 'P0000001',
          ItemCode: '0000001'
        },
        {
          GuideGoodsName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
          GuideStandardName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000002',
          ItemCode: '0000002'
        },
        {
          GuideGoodsName: '髙﨑😀<>',
          GuideStandardName: '髙﨑😀<>',
          JanCode: '345678901234',
          BuyerName: '髙﨑😀<>',
          PCode: 'P0000003',
          ItemCode: '0000003'
        },
        {
          GuideGoodsName: '555555555555555555555555555555',
          GuideStandardName: '999999999999999',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000004',
          ItemCode: '0000004'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000006',
          ItemCode: '0000006'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000007',
          ItemCode: '0000007'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000008',
          ItemCode: '0000008'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000009',
          ItemCode: '0000009'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000010',
          ItemCode: '0000010'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000011',
          ItemCode: '0000011'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000014',
          ItemCode: '0000014'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000015',
          ItemCode: '0000015'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000016',
          ItemCode: '0000016'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000017',
          ItemCode: '0000017'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000018',
          ItemCode: '0000018'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000019',
          ItemCode: '0000019'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000020',
          ItemCode: '0000020'
        },
        {
          GuideGoodsName: '商品A',
          GuideStandardName: '規格A',
          JanCode: '123456789012',
          BuyerName: 'バイヤーA',
          PCode: 'P0000001',
          ItemCode: '0000001'
        },
        {
          GuideGoodsName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
          GuideStandardName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000002',
          ItemCode: '0000002'
        },
        {
          GuideGoodsName: '髙﨑😀<>',
          GuideStandardName: '髙﨑😀<>',
          JanCode: '345678901234',
          BuyerName: '髙﨑😀<>',
          PCode: 'P0000003',
          ItemCode: '0000003'
        },
        {
          GuideGoodsName: '555555555555555555555555555555',
          GuideStandardName: '999999999999999',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000004',
          ItemCode: '0000004'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000006',
          ItemCode: '0000006'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000007',
          ItemCode: '0000007'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000008',
          ItemCode: '0000008'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000009',
          ItemCode: '0000009'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000010',
          ItemCode: '0000010'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000011',
          ItemCode: '0000011'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000006',
          ItemCode: '0000006'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000007',
          ItemCode: '0000007'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000008',
          ItemCode: '0000008'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000009',
          ItemCode: '0000009'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000010',
          ItemCode: '0000010'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000011',
          ItemCode: '0000011'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000012',
          ItemCode: '0000012'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000013',
          ItemCode: '0000013'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000014',
          ItemCode: '0000014'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000015',
          ItemCode: '0000015'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000016',
          ItemCode: '0000016'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000017',
          ItemCode: '0000017'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000018',
          ItemCode: '0000018'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000019',
          ItemCode: '0000019'
        },
        {
          GuideGoodsName: '商品B',
          GuideStandardName: '規格B',
          JanCode: '345678901234',
          BuyerName: 'バイヤーB',
          PCode: 'P0000020',
          ItemCode: '0000020'
        },
      ]
    }
  }
});

const getExistingGoodsCopy = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      JanCode: '12345678901',
      GoodsName: '商品名B',
      StandardName: '規格名B',
      ClassCode: '01',
      LargeClassCode: '01',
      MiddleClassCode: '0100',
      SmallClassCode: '010000',
      OrderUnitType: '0',
      SetQuantity: '1',
      SuggestedPriceSellingNormal: '200',
      SuggestedPriceSellingSpecial1: '190',
      SuggestedPriceSellingSpecial2: '185',
      SuggestedPricePurchaseNormal: '160',
      SuggestedPricePurchaseSpecial1: '160',
      SuggestedPricePurchaseSpecial2: '160',
      BundlePrice: '10',
      UnitPriceDiv: '0',
      UnitPriceCoefficient: '1',
      UnitPriceUnit: '１０',
      EdlpDiv: '0',
      ConsumeByDate: '1234',
      ConsumeTerm: '1234',
      SetDiv: '0',
      CaseSupplyDiv: '0',
      ArrivalAreaDiv: '00',
      ArrivalGoodsTemp: '0',
      ArrivalAdminDays: '1',
      BrandType: '00',
      EcologyDiv: '00',
      CycleTerm: '00',
      MakerPrice: '1',
      CoopCodeList: ['142', '185'],
      GoodsExplanation: '商品説明',
      Catchphrase: 'キャッチコピー',
      RecommendComment: 'レコメンド',
      UsefullInfoEnclosure: 'テスト',
      UsefullInfoConfiguration: 'テスト',
      UsefullInfoOther: 'テスト',
      UsefullInfoSize: 'テスト',
      HandleCaution: 'テスト',
      ConsumeTaxRate: '8',
      LiquorCode: '000',
      AlcoholType: '1',
      ContainerForm: '00',
      ApplyTermStart: '20240124',
      ApplyTermEnd: '20250131',
      SeasonConsumeDiv: '1',
      SeasonConsumeTermStart: '1234',
      SeasonConsumeTermEnd: '1234',
      StinkGoodsDiv: '0',
      ListingGoodsName: 'テスト',
      ListingType: 'テスト',
      ListingContentsQuantity: 'テスト',
      ListingSize: 'テスト',
      ListingSizeCm: 'テスト',
      ListingNumber: 'テスト',
      ListingColor: 'テスト',
      RelationPcodeDiv: 'P1234567',
      SpecialOrderType: '00',
      StockType: '0',
      PdPilingUpDays: '12',
      FactoryAddress1: 'テスト',
      FactoryAddress2: 'テスト',
      FcmcFee: '10',
    }
  }
};